(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
if(enable_minmax_buys){
_checkCartPageQuantities(mins, maxs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
// mob menu
let hamburger = document.querySelector('.hamburger');

if(hamburger){
    hamburger.addEventListener('click', function(){
        document.documentElement.classList.toggle('menu-open');
    });
}

// sub nav trigger
let subNavTriggers = document.querySelectorAll('.sub-menu-trigger');
subNavTriggers.forEach((el) => {
el.addEventListener('click', function(e){
e.preventDefault();
el.closest('li').classList.toggle('active');
});
});

// mega menu trigger
let mmLinks = document.querySelectorAll('.megamenu__links li a');
mmLinks.forEach(function(el, index){
el.addEventListener('mouseover', function(){
let thisIndex = el.dataset.index;
let relatedLists = el.closest('.megamenu').querySelectorAll('.megamenu li[data-index="'+thisIndex+'"]');
let activeLists =  el.closest('.megamenu').querySelectorAll('.megamenu li.active');

if(!relatedLists){
return;
}

activeLists.forEach((el) => {
el.classList.remove('active');
});

relatedLists.forEach((el) => {
el.classList.add('active');
});
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-cross-sells");

        if (productRecommendationsSection === null) { return; }


        // Build request URL
        var requestUrl = productRecommendationsSection.dataset.url;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();

        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300 && request.response !== "") {
                var container = document.createElement("div");
                container.innerHTML = request.response;

                productRecommendationsSection.innerHTML = container.querySelector(".product-cross-sells").innerHTML;

                if(document.querySelector(".product-cross-sells").textContent.trim() === ""){
                    document.querySelector(".product-cross-sells").closest('section').remove();
                } else {
                    window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
                    window.globalQuickView();
                }

            }else{
                window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
            }
        };

        request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-cross-sell") {
            loadProductRecommendationsIntoSection();
        }
    });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-recommendations");

        if (productRecommendationsSection === null) { return; }


        // Build request URL
        var requestUrl = productRecommendationsSection.dataset.url;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();

        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
                var container = document.createElement("div");
                container.innerHTML = request.response;

                productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
                
                window.initSlider(document.querySelector('.related-slider'), 1, 'section');

                window.globalQuickView();
            }
        };

        request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            loadProductRecommendationsIntoSection();
        }
    });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
